module.exports = __webpack_public_path__ + "assets/865bf17c00ac5ff52fcd6270da6a6f4d.mp3";